import React from 'react';
function getCircleStyle(diameter) {
    return {
        height: diameter,
        width: diameter,
        position: 'relative',
        borderRadius: '50%',
        background: '#549ADA',
    };
}
export default function WaferCircle({ diameter, size }) {
    const circleStyle = getCircleStyle(diameter);
    const containerStyle = {
        position: 'absolute',
        width: size,
        height: size,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'white',
        zIndex: -2,
    };
    return (React.createElement("div", { style: containerStyle },
        React.createElement("div", { style: circleStyle })));
}
//# sourceMappingURL=WaferCircle.js.map